import requests from "./httpServices";

export const getMeetingRooms = (currentPage, rowsPerPage) => {
  return requests.get(`/rooms?page=${currentPage}&limit=${rowsPerPage}`);
};

export const getScheduleMeeting = (currentPage, rowsPerPage) => {
  return requests.get(
    `/rooms/list-scheduled-meetings?page=${currentPage}&limit=${rowsPerPage}`
  );
};

export const getMeetingRoomById = (roomId) => {
  return requests.get(`/rooms/${roomId}`);
};

export const createMeetingRoom = (roomData) => {
  return requests.post("/rooms", roomData);
};

export const deleteMeetingRoom = (id) => {
  return requests.delete(`/rooms/${id}`);
};

export const updateMeetingRoom = (roomId, roomData) => {
  return requests.post(`/rooms/${roomId}`, roomData);
};

export const checkCreateRoomAailability = () => {
  return requests.get("/rooms/create-room-vailability");
};

export const createScheduledMeeting = (roomData) => {
  return requests.post("/rooms/create-schedule-meeting", roomData);
};

export const updateScheduledMeeting = (roomId, roomData) => {
  return requests.post(`/rooms/update-schedule-meeting/${roomId}`, roomData);
};

export const getScheduledMeetingById = (roomId) => {
  return requests.get(`/rooms/get-schedule-meeting/${roomId}`);
};

export const deleteScheduledMeeting = (roomId) => {
  return requests.delete(`/rooms/delete-schedule-meeting/${roomId}`);
};

export const checkRoomNameExists = (roomName) => {
  return requests.get(`/rooms/check-name/${encodeURIComponent(roomName)}`);
};

export const getLastMeetingSession = (roomId) => {
  return requests.post(`/rooms/meeting-last-session`, { roomId: roomId });
};

export const submitFeedback = (feedbackData) => {
  return requests.post(`/rooms/submit-feedback`, feedbackData);
};